export default { sha: '87fe5344bbae9ded84c59926ef920e88cddaeadd', buildNumber: 'undefined' }
